import { render, staticRenderFns } from "./CountryItem.vue?vue&type=template&id=734250f8&scoped=true&"
import script from "./CountryItem.vue?vue&type=script&lang=ts&"
export * from "./CountryItem.vue?vue&type=script&lang=ts&"
import style0 from "./CountryItem.vue?vue&type=style&index=0&id=734250f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734250f8",
  null
  
)

export default component.exports